module.exports = __webpack_public_path__ + "img/symbol_10_x2.0216ca5f.png";